export interface LoginInterface {
  email: string;
  password: string;
}

export interface LoginResponseInterface {
  token: string;
  is_mfa_disabled: boolean;
}

export interface ForgotPasswordInterface {
  email: string;
}

export interface OtpVerifyInterface {
  email: string;
  verification_code: string;
}

export interface ResetPasswordInterface {
  email: string;
  new_password: string;
  confirm_password: string;
}

export interface UserPermissionDetailsInterface {
  partnerLogo: string;
  userDetails: UserDetailsInterface;
  userPermissionDetails: {
    permissions: UserPermissionsInterface[];
  };
}

export interface UserDetailsInterface {
  address1: string;
  address2: string;
  city: string;
  date_of_birth: string;
  email: string;
  first_name: string;
  gender: string;
  id: number;
  is_mfa_disabled: boolean;
  is_partner_admin: boolean;
  is_super_admin: boolean;
  last_name: string;
  logo: string;
  middle_name: string;
  mobile_number: string;
  mode: string;
  nationality: string;
  partner_id: number;
  postal_code: string;
  source_country: string;
  user_email_partner_id: string;
  user_id: string;
}

export interface UserPermissionsInterface {
  api_endpoint: string;
  created_at: string;
  created_by: string;
  description: string;
  display_in_menu: boolean;
  id: number;
  is_active: boolean;
  is_deleted: boolean;
  partner_id: number;
  permission_id: string;
  permission_type: string;
  slug: string;
  title: string;
  updated_at: string;
}

export interface UserInfoInterface {
  userName: string;
  userEmail: string;
  userId: string;
  logo: string;
  mode?: string;
  partnerId?: number;
}

export const DEFAULT_USER: UserInfoInterface = {
  userName: '',
  userEmail: '',
  userId: '',
  logo: '',
};
